(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ob-instagram"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* json mode: fill the existing photo slots with the newest posts of a JSON feed — the Instafeed app's public
     feed endpoint (api.nfcube.com/feed/v5?…&hash=<feed hash from the app's storefront script>: data[].images
     .standard_resolution.url + link + caption), Behold, or any {posts|data:[…]} array with mediaUrl/permalink-like
     fields. Only http(s) URLs are accepted; on any failure the server-rendered manual photos stay. */
  function safeUrl(value) {
    if (typeof value !== 'string') return null;
    try {
      var u = new URL(value, window.location.origin);
      return (u.protocol === 'https:' || u.protocol === 'http:') ? u.href : null;
    } catch (e) { return null; }
  }
  function postImage(post) {
    if (!post || typeof post !== 'object') return null;
    if (post.sizes && post.sizes.medium && post.sizes.medium.mediaUrl) return safeUrl(post.sizes.medium.mediaUrl);
    if ((post.mediaType || post.media_type) === 'VIDEO') {
      var thumb = safeUrl(post.thumbnailUrl || post.thumbnail_url);
      if (thumb) return thumb;
    }
    if (post.images && post.images.standard_resolution && post.images.standard_resolution.url) {
      return safeUrl(post.images.standard_resolution.url);            /* Instafeed feed/v5 */
    }
    return safeUrl(post.mediaUrl || post.media_url || post.thumbnailUrl || post.thumbnail_url || post.imageUrl || post.image_url);
  }
  function postAlt(post) {
    var text = post && (post.caption && post.caption.text || post.caption || post.prunedCaption || '');
    if (typeof text !== 'string') return '';
    text = text.split('\n')[0].replace(/#\S+/g, '').replace(/\s+/g, ' ').trim();
    return text.length > 120 ? text.slice(0, 117) + '…' : text;
  }
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  function fillCell(cell, post, root) {
    var img = document.createElement('img');
    img.className = 'ob-insta__img';
    img.src = postImage(post);
    img.loading = 'lazy';
    img.decoding = 'async';
    img.alt = postAlt(post);
    cell.textContent = '';
    cell.appendChild(img);
    cell.href = safeUrl(post.permalink || post.link) || root.dataset.profileUrl || cell.href;
  }

  function initFeed(root) {
    var url = safeUrl(root.dataset.feedUrl);
    var cells = root.querySelectorAll('.ob-insta__cell');
    if (!url || !cells.length || root.dataset.feedLoaded) { initBelt(root); return; }
    root.dataset.feedLoaded = '1';
    fetch(url)
      .then(function (res) { if (!res.ok) throw new Error('feed ' + res.status); return res.json(); })
      .then(function (data) {
        var posts = (Array.isArray(data) ? data : (data.posts || data.data || [])).filter(function (post) { return !!postImage(post); });
        var grid = root.querySelector('.ob-insta__grid');
        posts.forEach(function (post, n) {
          if (n < cells.length) { fillCell(cells[n], post, root); return; }
          // SV46: the belt shows every feed post, not only the 5 slots
          if (root.dataset.autoscroll !== 'true' || !grid) return;
          var cell = cells[0].cloneNode(false);
          cell.removeAttribute('id');
          cell.removeAttribute('data-shopify-editor-block');
          cell.setAttribute('aria-label', postAlt(post) || cells[0].getAttribute('aria-label') || '');
          fillCell(cell, post, root);
          grid.appendChild(cell);
        });
        initBelt(root);
      })
      .catch(function () { delete root.dataset.feedLoaded; initBelt(root); });
  }

  /* SV46: endless belt. Each cell keeps its Figma width slot (1 / 2 / 3 / 2 / 1 …) as a class, so the clones are
     pixel-identical and moving the belt by exactly one set width loops without a jump. */
  function initBelt(root) {
    if (root.dataset.autoscroll !== 'true' || root.dataset.beltReady || REDUCED.matches) return;
    var grid = root.querySelector('.ob-insta__grid');
    if (!grid) return;
    var cells = Array.prototype.slice.call(grid.querySelectorAll('.ob-insta__cell'));
    if (cells.length < 2) return;
    root.dataset.beltReady = '1';
    var slots = [1, 2, 3, 2, 1];
    cells.forEach(function (cell, i) { cell.classList.add('ob-insta__cell--w' + slots[i % 5]); });
    var belt = document.createElement('div');
    belt.className = 'ob-insta__belt';
    cells.forEach(function (cell) { belt.appendChild(cell); });
    grid.appendChild(belt);
    grid.classList.add('is-belt');
    var copies = 0;
    var speed = Math.max(5, parseFloat(root.dataset.autoscrollSpeed) || 30);
    function addCopy() {
      cells.forEach(function (cell) {
        var clone = cell.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('tabindex', '-1');
        clone.removeAttribute('id');
        clone.removeAttribute('data-shopify-editor-block');
        belt.appendChild(clone);
      });
      copies++;
    }
    function measure() {
      var gap = parseFloat(getComputedStyle(belt).columnGap) || 0;
      var setW = cells.reduce(function (sum, cell) { return sum + cell.getBoundingClientRect().width + gap; }, 0);
      if (!(setW > 0)) return;
      while ((copies + 1) * setW < grid.clientWidth + setW && copies < 6) addCopy();   // ≥ one screen + one set
      belt.style.setProperty('--ob-insta-belt-shift', (-setW).toFixed(2) + 'px');
      belt.style.animationDuration = (setW / speed).toFixed(2) + 's';
    }
    measure();
    if (window.ResizeObserver) new ResizeObserver(measure).observe(grid);
    var resumeTimer;
    grid.addEventListener('touchstart', function () {
      clearTimeout(resumeTimer);
      grid.classList.add('is-paused');
    }, { passive: true });
    grid.addEventListener('touchend', function () {
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () { grid.classList.remove('is-paused'); }, 2500);
    }, { passive: true });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.ob-insta').forEach(function (root) {
      if (root.dataset.feedUrl) initFeed(root); else initBelt(root);
    });
  }
  initAll();
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
